/**
 * RESPONSIBILITY: the grid of every ministry as a card.
 *
 * The requirements doc asks that the menu lands here, showing the same children as large
 * cards. This band carries the pencil for the LIST — the page's heading has its own
 * beside it, so a pencil always opens the thing it sits over.
 *
 * It is HANDED the ministries rather than reading them off the section, because which of
 * them a visitor may see is a permission question and those do not belong in here.
 *
 * It is also handed, optionally, how to draw a card. A pencil on each card is editing, and
 * editing is not this file's business - the page supplies it for whoever may edit, and
 * everybody else gets the plain card, so a visitor's markup is exactly what it always was.
 */
import { Fragment, type ReactNode } from 'react';
import { idOf } from '@framework/core';
import type { Ministry } from '@app/sections';
import { MinistryCard } from './MinistryCard';

export function Ministries(
  { ministries, card }: { ministries: readonly Ministry[]; card?: (m: Ministry) => ReactNode },
) {
  return (
    <section className="band">
      <div className="wrap">
        <div className="grid grid-4">
          {ministries.map((m) => (card
            ? <Fragment key={idOf(m)}>{card(m)}</Fragment>
            : <MinistryCard key={idOf(m)} m={m} />))}
        </div>
      </div>
    </section>
  );
}
